import gql from 'graphql-tag';

export const APPLICATION_FRAGMENT = gql`
  fragment ApplicationFragment on Application {
    id
    name
    icon
  }
`;
